<main>
  <ng-container [ngTemplateOutlet]="titlePage"></ng-container>
  <ng-container [ngTemplateOutlet]="pageContent"></ng-container>
</main>

<ng-container #filters></ng-container>

<ng-template #titlePage>
  <div class="search-result-title">
    <ng-container [ngTemplateOutlet]="crumbs"></ng-container>
    <span class="filters-wrapper" (click)="switcherFilter()">
      <span class="filter-switcher" [ngClass]="{'filter-switcher-enable': (countActiveFilters | async) > 0}"></span>
      <span *ngIf="(countActiveFilters | async) > 0" class="filter-text"
        [innerHTML]="'activeFilters' | transloco"></span>
      <span *ngIf="(countActiveFilters | async) === 0" class="filter-text"> {{'filters' | transloco}} </span>
      <span *ngIf="(countActiveFilters | async) > 0" class="filter-number">&nbsp;({{countActiveFilters |
        async}})</span>
    </span>
    <span [textContent]="_search_history_name"></span>
    <span class="founed-in-city">
      {{ totalGoodsNumber | async | mathround }}
      <!-- Temp fix for ngx-pagination -->
      {{'inSityShort' | transloco}}
      <span class="city-colored" (click)="toChangeRegion()">
        <ng-container *ngIf="isPreparatPage else selectedCity">{{ (preparatSeoData | async)?.townName }}</ng-container>
        <ng-template #selectedCity>{{ selectCurrentCity | async }}</ng-template>
      </span>
    </span>
  </div>
  <h1 class="category-heading" *ngIf="seoData?.h1">{{seoData?.h1}}</h1>
  <h1 class="category-heading" *ngIf="isSearchPage || isPreparatPage">
    <ng-container *ngIf="!isSearchTradeName && !isPreparatPage">
      {{'youSearch' | transloco}} «{{searchByEnterValue}}»
    </ng-container>
    <ng-container *ngIf="isSearchTradeName || isPreparatPage">
      {{ titleForListPage | async }}
      <span *ngIf="!p?.isFirstPage()">- {{ 'page' | transloco }} {{ p?.getCurrent() }}</span>
    </ng-container>
  </h1>
  <div class="list-mobile-crumbs" *ngIf="isSearchTradeName">
    <ng-container [ngTemplateOutlet]="crumbs"></ng-container>
  </div>
  <div class="no-product" *ngIf="(preparatBloks | async)?.length === 0 && !(loading | async)" [textContent]="'emptySearch' | transloco"></div>
</ng-template>

<ng-template #pageContent>
  <div class="search-result-products scrollbar">
    <bz-spinner *ngIf="loading | async"></bz-spinner>
    <div class="inner scrollable-block" style="position: relative">
      <bz-product *ngFor="
              let item of preparatBloks | async  | paginate: {
                  itemsPerPage: 12,
                  currentPage: (pages | async),
                  totalItems: (totalGoodsNumber | async)
                }; trackBy: trackById
            " [BzProduct]="item" [isSearchPage]="true" [townForNavigateUrl]="currentTownForPreparatPage"></bz-product>
    </div>

    <ng-container [ngTemplateOutlet]="preparatBanner"></ng-container>
    <ng-container [ngTemplateOutlet]="categoryBanner"></ng-container>
    <ng-container [ngTemplateOutlet]="listBanner"></ng-container>

    <ng-container *ngIf="!p?.isLastPage()">
      <div class="show-more-wrapper" *ngIf="p?.getCurrent() < p?.getLastPage()">
        <div class="still" (click)="showMore()">
          <span>{{'show_more' | transloco}}</span>
        </div>
      </div>
    </ng-container>

    <pagination-template maxSize="5" class="wrapper-pagination" [ngStyle]="{
                'margin-bottom': '0px',
                'padding': p.getLastPage() <= 1 ? '0px' : '10px 0px'
            }" #p="paginationApi">
      <ng-container *ngIf="p.getLastPage() > 1">
        <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
          <a [class.disabled]="p.isFirstPage()" (click)="pageChange(p.getCurrent() - 1); p.previous()"
            [routerLink]="returnLinkPagination(p.getCurrent() - 1)" queryParamsHandling="merge"></a>
        </div>

        <div class="wrapper-link-page" *ngFor="let page of p.pages" [class.current]="p?.getCurrent() === page.value">
          <a (click)="pageChange(page.value)" [routerLink]="returnLinkPagination(page.value)"
            queryParamsHandling="merge" *ngIf="p?.getCurrent() !== page.value">
            <span>{{ page.label }}</span>
          </a>
          <div *ngIf="p?.getCurrent() === page.value">
            <span>{{ page.label }}</span>
          </div>
        </div>

        <span class="info-pages">{{'page' | transloco}} {{p?.getCurrent()}} {{'of' | transloco}}
          {{p.getLastPage()}}</span>

        <div class="pagination-next" [class.disabled]="p.isLastPage()">
          <a *ngIf="!p.isLastPage()" (click)="pageChange(p.getCurrent() + 1); p.next()"
            [routerLink]="returnLinkPagination(p.getCurrent() + 1)" queryParamsHandling="merge"></a>
          <a *ngIf="p.isLastPage()" [class.disabled]="p.isLastPage()"></a>
        </div>
      </ng-container>
    </pagination-template>

    <!-- Ниже список теймплейтов, которые рендерятся ниже пагинации  -->
    
    <ng-container [ngTemplateOutlet]="seoTableForTradeNamePage"></ng-container>

    <ng-container [ngTemplateOutlet]="seoAuthorForCategoryPage"></ng-container>

    <ng-container [ngTemplateOutlet]="seoTextForCategoryPage"></ng-container>

    <ng-container [ngTemplateOutlet]="seoWarningForTradeNamePage"></ng-container>

    <ng-container [ngTemplateOutlet]="seoFAQForTradeNamePage"></ng-container>

    <ng-container [ngTemplateOutlet]="purchaseProcess"></ng-container>

    <ng-container [ngTemplateOutlet]="seoAnalogsForTradeNamePage"></ng-container>

    <ng-container [ngTemplateOutlet]="moreTownsTemplate" [ngTemplateOutletContext]="{ forPreparatPage: false }"></ng-container>

    <ng-container [ngTemplateOutlet]="tableForPreparatPage"></ng-container>

    <ng-container [ngTemplateOutlet]="faqForPreparatPage"></ng-container>

    <ng-container [ngTemplateOutlet]="pharmaciesForPreparatPage"></ng-container>

    <ng-container [ngTemplateOutlet]="moreTownsTemplate" [ngTemplateOutletContext]="{ forPreparatPage: true }"></ng-container>

    <ng-container [ngTemplateOutlet]="footer"></ng-container>
  </div>
</ng-template>

<ng-template #crumbs>
  <ng-container *ngIf="(references | async)?.length > 0">
    <nav class="references-wrapper">
      <a class="reference-btn" [routerLink]="getHomePageLink()">{{'search-for-drugs' | transloco}}</a>
      <ng-container *ngFor="let item of (references | async)">
        <a class="reference-btn" [routerLink]="getLinkFromCrumb(item)"
          (click)="toSearchFromCrumbs(item)">{{ item?.name }}</a>
      </ng-container>
    </nav>
  </ng-container>
</ng-template>

<ng-template #seoTextForCategoryPage>
  <ng-container *ngIf="(preparatBloks | async)?.length">
    <div *ngIf="seoTextUnderPagination | async" class="seo-text-wrapper inner">
      <div class="seo-text" [class.full-text]="showFullSeoText" [innerHTML]="seoTextUnderPagination | async | safeHTML">
      </div>
      <div class="read-more" (click)="readMoreSeoText()">{{ showFullSeoText ? ('hide' | transloco) : ('read-more' |
        transloco) }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #seoAuthorForCategoryPage>
  <div class="seo-editor inner" *ngIf="seoEditor | async as editor">
    <bz-instruction-author
      [addExtraMarginBottom]="(seoTextUnderPagination | async) === null"
      [showLeftSide]="false"
      [seoControl]="{ editor: editor }"
    ></bz-instruction-author>
  </div>
</ng-template>

<ng-template #seoFAQForTradeNamePage>
  <ng-container *ngIf="(seoFaqForTradeNameListPage | async)?.seoText && p?.isFirstPage()">
    <div class="faq-seo-text inner" [innerHTML]="(seoFaqForTradeNameListPage | async).seoText"></div>
  </ng-container>

  <ng-container *ngIf="(preparatBloks | async)?.length && p?.isFirstPage()">
    <bz-faq
      class="inner"
      [faqs]="(seoFaqForTradeNameListPage | async)?.faqs"
      [heading]="(seoFaqForTradeNameListPage | async)?.h2"
      [text]="(seoFaqForTradeNameListPage | async)?.text"
    ></bz-faq>
  </ng-container>
</ng-template>

<ng-template #seoWarningForTradeNamePage>
  <ng-container *ngIf="p?.isFirstPage()">
    <div class="warning-msg inner" *ngIf="(seoFaqForTradeNameListPage | async)?.warning as warning">
      <bz-instruction-author
        [showRightSide]="false"
        [seoControl]="{ warning: warning }"
      ></bz-instruction-author>
    </div>
  </ng-container>
</ng-template>

<ng-template #purchaseProcess>
  <div class="inner" *ngIf="(seoFaqForTradeNameListPage | async)?.howToBuy.length && p?.isFirstPage()">
    <bz-help-center
      [heading]="(titleForListPage | async)"
      [items]="(seoFaqForTradeNameListPage | async).howToBuy"
    ></bz-help-center>
  </div>
</ng-template>

<ng-template #seoTableForTradeNamePage>
  <ng-container *ngIf="(preparatBloks | async)?.length && p?.isFirstPage()">
    <div *ngIf="(seoTableWithPrices | async)?.prices.length" class="inner" style="z-index: 1;">
      <bz-prices-table [table]="seoTableWithPrices | async" [lang]="currentLang" [isListPage]="true"
        [tableHeading]="('price-on' | transloco) + ' ' + (seoTableWithPrices | async)?.ctName">
      </bz-prices-table>
    </div>
  </ng-container>
</ng-template>

<ng-template #seoAnalogsForTradeNamePage>
  <ng-container *ngIf="(preparatBloks | async)?.length && p?.isFirstPage()">
    <div *ngIf="!!(seoAnalogListProducts | async)" class="seo-analogs inner" style="z-index: 1;">
      <h2 class="analogs-heading">Аналоги {{ titleForListPage | async }}</h2>
      <div class="analogs-products">
        <ng-container *ngIf="(seoAnalogListProducts | async)?.length > 0">
          <bz-product *ngFor="let product of (seoAnalogListProducts | async)" [BzProduct]="product"
            [isSearchPage]="true">
          </bz-product>
        </ng-container>
        <ng-container *ngIf="(seoAnalogListProducts | async)?.length === 0">
          <p class="no-analogs-found">{{ 'noAnalogs' | transloco }}</p>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #moreTownsTemplate let-forPreparatPage="forPreparatPage">
  <ng-container *ngIf="p?.isFirstPage()">
    <div class="more-towns-wrapper inner">
      <bz-towns-list
        [moreTowns]="forPreparatPage ? (preparatSeoData | async)?.moreTowns : (seoFaqForTradeNameListPage | async)?.moreTowns"
        [moreTownText]="forPreparatPage ? (preparatSeoData | async)?.moreTownText : (seoFaqForTradeNameListPage | async)?.moreTownText"
        [searchTarget]="searchTarget | async"
        (onResetScroll)="resetPageScroll()">
      </bz-towns-list>
    </div>
  </ng-container>
</ng-template>

<ng-template #faqForPreparatPage>
  <ng-container *ngIf="isPreparatPage && p?.isFirstPage()">
    <bz-faq
      class="inner faq-for-preparat"
      [faqs]="(preparatSeoData | async)?.faqs"
      [heading]="(preparatSeoData | async)?.faqTitle"
      [text]="(preparatSeoData | async)?.faqText"
    ></bz-faq>
  </ng-container>
</ng-template>

<ng-template #pharmaciesForPreparatPage>
  <ng-container *ngIf="isPreparatPage && p?.isFirstPage()">
    <div class="pharmacies-wrapper inner">
      <h2 class="pharmacy-info-heading">{{ (preparatSeoData | async)?.existText }}</h2>
      <bz-pharmacy-info
        [exists]="(preparatSeoData | async)?.exists"
        (onTogglePharmacy)="togglePharmacy($event)">
      </bz-pharmacy-info>
    </div>
  </ng-container>
</ng-template>

<ng-template #tableForPreparatPage>
  <ng-container *ngIf="isPreparatPage && p?.isFirstPage() && (preparatSeoData | async)?.seoPrice">
    <div class="table-wrapper inner">
      <bz-prices-table
        [table]="(preparatSeoData | async).seoPrice"
        [lang]="currentLang"
        [isPreparatPage]="true"
        [tableHeading]="(preparatSeoData | async).seoPrice.h2">
      </bz-prices-table>
    </div>
  </ng-container>
</ng-template>

<ng-template #preparatBanner>
  <ng-container *ngIf="p?.isFirstPage()">
    <ng-container *ngIf="(preparatSeoData | async)?.adBanner as preparatBanner">
      <div class="banner inner">
        <a [href]="preparatBanner.redirectTo">
          <picture class="banner-picture">
            <source [srcset]="bannerImages + preparatBanner.img + '.webp'" type="image/webp">
            <img class="inner" bz-image [src]="bannerImages + 'png/' + preparatBanner.img + '.png'" [title]="'Банер'" [alt]="'Банер'">
          </picture>
        </a>
      </div>
    </ng-container>
  </ng-container>
</ng-template>


<ng-template #categoryBanner>
  <ng-container *ngIf="p?.isFirstPage()">
    <ng-container *ngIf="(banner | async) as categoryBanner">
      <div class="banner inner">
        <a [href]="categoryBanner.redirectTo">
          <picture class="banner-picture">
            <source [srcset]="bannerImages + categoryBanner.img + '.webp'" type="image/webp">
            <img class="inner" bz-image [src]="bannerImages + 'png/' + categoryBanner.img + '.png'" [title]="'Банер'" [alt]="'Банер'">
          </picture>
        </a>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #listBanner>
  <ng-container *ngIf="p?.isFirstPage()">
    <ng-container *ngIf="(seoTableWithPrices | async)?.adBanner as listBanner">
      <div class="banner inner">
        <a [href]="listBanner.redirectTo">
          <picture class="banner-picture">
            <source [srcset]="bannerImages + listBanner.img + '.webp'" type="image/webp">
            <img class="inner" bz-image [src]="bannerImages + 'png/' + listBanner.img + '.png'" [title]="'Банер'" [alt]="'Банер'">
          </picture>
        </a>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #footer>
  <div class="static-footer">
    <bz-static-footer [isSearchPage]="true"></bz-static-footer>
  </div>
</ng-template>
